export default __webpack_public_path__ + "static/media/logo.96315c20.svg";